export default "__VITE_ASSET__CiaTefuD__"